import { render, staticRenderFns } from "./MovablePopup.vue?vue&type=template&id=8347e1f4&scoped=true&"
import script from "./MovablePopup.vue?vue&type=script&lang=js&"
export * from "./MovablePopup.vue?vue&type=script&lang=js&"
import style0 from "./MovablePopup.vue?vue&type=style&index=0&id=8347e1f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8347e1f4",
  null
  
)

export default component.exports